import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { useLocation } from "react-router-dom";

import { Trans } from "react-i18next";
import { formatDateName } from "services/util";
import { Page } from "components/common";
import BackButton from "components/refactoring/BackButton";
import { XeroClient } from "services";
import { ExSpan } from "../Settings/TaxReturnsDetail";
import { useAccounts } from "queries";
import { Link } from "react-router-dom";


const ViewBatchPayment = ({ match, t }) => {
    const xero = XeroClient();
    const location = useLocation();
    const [viewBatchPayment, setViewBatchPayment] = useState([]);
    const batch_payment = location?.state || [];
    
    const id = match?.params?.batch_payment_id;
    const { data: accounts } = useAccounts({
        placeholderData: [],
    });
    useEffect(() => {
      if (!batch_payment?.length > 0) {
      getPayments(id);
      }
  }, []);

      const getPayments = async (id) => {
        await xero.get(`/batchpayments/${id}`).then(data => setViewBatchPayment(data?.data));
      };

    const accountID = viewBatchPayment ? viewBatchPayment?.Account?.AccountID : batch_payment?.response?.Account?.AccountID;

    const accountName = accounts?.length > 0 ? accounts.find(option => option.AccountID === accountID)?.Name : "-";
    
    const payments = batch_payment?.Payments ? batch_payment?.Payments : viewBatchPayment?.Payments;
    
    

    return (
        <Page title={t("Transaction: Batch Payment")}>
            
            <div>
            <BackButton />
            </div>
            <div className="d-flex justify-content-even">
                <ExSpan value={formatDateName(viewBatchPayment ? viewBatchPayment?.DateString : batch_payment?.response?.DateString)} label="Payment Date"/>
                <div className="ml-2"></div>
                    <ExSpan value={viewBatchPayment ? viewBatchPayment?.Reference : batch_payment?.response?.Reference} label={t("Details")}/>
                <div className="ml-2"></div>
                {accountName && (
                    <ExSpan value={<Link className="text_color" to={`/bank/bank_accounts/${viewBatchPayment ? viewBatchPayment?.Account?.AccountID : batch_payment?.response?.Account?.AccountID}/bank_transactions`}>{accountName}</Link>} label={t("Bank Account")}/>
                )}
            </div>
            <hr />
            
            <Table>
                <thead>
                    <tr>
                        {batch_payment?.Payments?.length > 0 && (
                            <th>
                                <Trans>To</Trans>
                            </th>
                        )}
                        <th>
                            <Trans>Ref</Trans>
                        </th>
                        <th>
                            <Trans>Details</Trans> <span><Trans> <strong>To appear on contact's bank statement</strong></Trans></span>
                        </th>
                        {batch_payment?.Payments?.length > 0 && (
                            <th>
                                <Trans>Due Date</Trans>
                            </th>
                        )}
                        <th>
                            <Trans>Payment Amount</Trans>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {payments?.map((payment, index) => (
                        <tr>
                            {batch_payment?.Payments?.length > 0 && (
                                <td>
                                    { batch_payment?.Contacts[index]?.Contact?.Name}
                                </td>
                            )}
                            <td>
                                <Link className="text_color" to={`/accounts_receivable/invoices/view/${viewBatchPayment ? payment?.Invoice?.InvoiceID : batch_payment?.Payments[index]?.Invoice?.InvoiceID}`}>{payment?.Reference}</Link>
                            </td>
                            <td>
                            {viewBatchPayment ? viewBatchPayment?.Reference : batch_payment?.response?.Reference}
                            </td>
                            {batch_payment?.Payments?.length > 0 && (
                            <td>
                                {formatDateName(payment?.DueDateString)}
                            </td>
                            )}
                            <td>
                                {payment?.Amount}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div className="d-flex justify-content-end" >
                <Table className="w-25" size="sm" bordered>
                <tbody>
                    <tr>
                        <th>
                            <Trans>Total</Trans>
                        </th>
                        <th>
                            {viewBatchPayment ? viewBatchPayment?.TotalAmount : batch_payment?.response?.TotalAmount}
                        </th>
                    </tr>
                </tbody>
                </Table>
            </div>
        </Page>
    );
};

export default ViewBatchPayment;
